import { render, staticRenderFns } from "./modalProveedoresProductos.vue?vue&type=template&id=6a372ecb&"
import script from "./modalProveedoresProductos.vue?vue&type=script&lang=js&"
export * from "./modalProveedoresProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports